import {AUTH_LOGOUT} from '@/store/actions/auth';

import Vue from 'vue'
import Vuex from 'vuex'

import {mapState, mapGetters} from 'vuex';

import axios from 'axios'

import VueAxios from 'vue-axios'

/**
 * i18n
 */
import {i18n} from './lang/config.js';

import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import store from './store'

import VueFlashMessage from 'vue-flash-message';
import 'vue-flash-message/dist/vue-flash-message.min.css';

Vue.use(VueFlashMessage);

// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import 'es6-promise/auto'

// Datepicker
import Datepicker from 'vuejs-datepicker';

Vue.component('datepicker', Datepicker);

import Loader from './components/Loader'

Vue.component('loader', Loader);

import vSelect from 'vue-select'

Vue.component('v-select', vSelect)

import FullCalendar from 'vue-full-calendar'

Vue.use(FullCalendar)
import 'fullcalendar/dist/fullcalendar.css'
import 'fullcalendar/dist/locale/de'

import moment from 'moment'

moment.locale("en");
Vue.prototype.moment = moment

Vue.config.productionTip = false

Vue.use(BootstrapVue);
Vue.use(Vuex);
Vue.use(VueAxios, axios);

/**
 * Vee validate
 */
import VeeValidate from 'vee-validate';

/**
 * Max word validator extend
 */

const maxWords = {
    validate(value, {max} = {}) {
        let words = value.split(/\s+/).filter(el => {
            return el.length > 0
        });

        return words.length <= max;
    },
    getMessage(field, max) {
        return i18n.tc('message.Guideline.maxWordsError') + max;
    },
};

// The first param is called 'min', and the second is called 'max'.
const paramNames = ['max'];

VeeValidate.Validator.extend('max-words', maxWords, {
    paramNames //  pass it in the extend options.
});

Vue.use(VeeValidate, {fieldsBagName: 'veeFields'});

/**
 * Sweetalert2
 */
import VueSweetalert2 from 'vue-sweetalert2';

Vue.use(VueSweetalert2);

/**
 * Font Avesome
 */
import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faCoffee,
    faCircle,
    faInfoCircle,
    faTimes,
    faCheckCircle,
    faEdit,
    faThumbsUp,
    faTrash,
    faDownload,
    faExclamationCircle,
    faCog,
    faInfo, faFileDownload
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

// <i class="fas fa-exclamation-circle"></i>

library.add(faCoffee, faCircle, faInfoCircle, faTimes, faCheckCircle, faEdit, faThumbsUp, faTrash, faDownload, faFileDownload, faExclamationCircle, faCog, faInfo)

Vue.component('font-awesome-icon', FontAwesomeIcon)

/**
 * Mixins
 */
Vue.mixin({
    computed: {
        ...mapState({
            dataLoading: state => state.guidelines.status === 'loading',
            dataError: state => state.guidelines.status === 'error',
            dataEmpty: state => state.guidelines.status === 'empty',
        }),
        ...mapGetters([
            'isGpc',
            'isIgo',
            'isCommitteeUser',
            'isNationalDelegate',
            'isSuperUser',
            'getUserData',
            'getAuthToken',
            'getPhaseFilter',
            'isAuthenticated',
        ]),

        version() {
            return process.env.VUE_APP_VERSION;
        },

        uploadUrl() {
            return process.env.VUE_APP_API_URL + 'files/' + this.guideline.id + '/';
        },

        uploadChunkedUrl() {
            return process.env.VUE_APP_API_URL + 'files-chunked/' + this.guideline.id + '/';
        },
        currentGuidelinePhaseLabel() {
            let phaseLabel = this.$t('message.Guideline.phase' + this.guideline.phase);
            return phaseLabel.replace('<br>', '');
        },
    },
    methods: {
        handleUnauth(status) {
            if (status == 401) {
                this.$store.dispatch(AUTH_LOGOUT);
                this.$router.go('/');
            }
        },

        handleForbidden(status) {
            if (status == 403) {
                this.$swal({
                    title: this.$t("message.forbidden"),
                    text: this.$t("message.thisActionIsForbidden"),
                    type: 'warning',
                    showCancelButton: false,
                })
            }
        },

        handleUnprocessable(response) {
            if (response.status == 422) {
                let message = response.data.message;

                for (let x in response.data.errors) {
                    message += '<br>' + response.data.errors[x];
                }

                this.$swal({
                    title: this.$t("message.unprocessable"),
                    html: message,
                    type: 'warning',
                    showCancelButton: false,
                })
            }
        },
        /**
         * Methods that check reviewer role in guideline
         * @param  {[type]} guideline [description]
         * @return {[type]}           [description]
         */
        imReviewer(guideline) {
            return guideline.review_user_ids.filter(elem => {
                return elem.value == this.getUserData.id
            }).length;
        },

        /**
         * [inputFilter for file uploader]
         * @param  {[type]} newFile [description]
         * @param  {[type]} oldFile [description]
         * @param  {[type]} prevent [description]
         * @return {[type]}         [description]
         */
        inputFilter(newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Before adding a file
                // Filter system files or hide files

                if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                    return prevent()
                }
                // Filter php html js file
                if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                    return prevent()
                }
            }
        },
    },
})

new Vue({
    render: h => h(App),
    router,
    store,
    i18n
}).$mount('#app')
